var Acr = Acr || {};

Acr.NavHelper = (function () {


  var Utility = window.Utility || {};

  var $wrapper = $('.wrapper');

  var hideMenuOnScroll = Acr.hideMenuOnScroll || false;

  var $window = $(window);

  var lastScrollTop = 0;

  function peekABoo() {
    var st = $window.scrollTop();

    if (st + 180 < lastScrollTop || st <= 0) {
      if ($wrapper.hasClass('collapsed-nav')) {
        $wrapper.removeClass('collapsed-nav');
      }

      if (!$wrapper.hasClass('expanded-nav')) {
        $wrapper.addClass('expanded-nav');

        // Add an event to the document when Global Nav is expands or collapses
        Utility.fireEvent(document, 'expandedGlobalNav');
      }
      lastScrollTop = st;
    }
    if (st - 180 > lastScrollTop) {
      if ($wrapper.hasClass('expanded-nav')) {
        $wrapper.removeClass('expanded-nav');
      }

      if (!$wrapper.hasClass('collapsed-nav')) {
        $wrapper.addClass('collapsed-nav');

        // Add an event to the document when Global Nav is expands or collapses
        Utility.fireEvent(document, 'expandedGlobalNav');
      }

      lastScrollTop = st;
    }

  }

  function init() {
    try {

      if (hideMenuOnScroll) {
        $window.on('scroll orientationchange', $.throttle(250, peekABoo));

        $wrapper.addClass('expanded-nav');
      }

    } catch (e) {
      Utility.error(e);
    }
  }

  return {
    init: init,
  };

}());
